var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-button',{attrs:{"type":"info"},on:{"click":function($event){return _vm.IOSclient()}}},[_vm._v("点击跳转ios下载页")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }